import React from 'react'
import PropTypes from 'prop-types'
import AsyncSelectRaw from '~/components/common/AsyncSelect'

const AsyncSelect = ({
  forwardValues,
  revertValues,
  field,
  form,
  onCreateNew,
  disabled,
  ...props
}) => (
  <AsyncSelectRaw
    {...field}
    values={forwardValues(field.value)}
    onChange={(v) => form.setFieldValue(field.name, revertValues(v))}
    onCreateNew={onCreateNew}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

AsyncSelect.defaultProps = {
  forwardValues: (v) => v,
  revertValues: (v) => v,
  onCreateNew: (v) => v,
  disabled: false,
}

AsyncSelect.propTypes = {
  forwardValues: PropTypes.func,
  revertValues: PropTypes.func,
  onCreateNew: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default AsyncSelect
